import { useState } from 'react';

import useDebounce from './useDebounce';

export function useDebouncedInput<T>(initialValue: T, name?: string) {
  const [value, setValue] = useState(initialValue);
  const debouncedValue = useDebounce(value, 500);

  return {
    value: debouncedValue,
    setValue,
    reset: () => setValue(initialValue),
    bind: {
      value,
      name,
      onChange: (event: any) => {
        setValue(event.target.value);
      },
      setValue: (val: T) => setValue(val),
    },
  };
}
